import { Link, Navigate } from "react-router-dom";
import { isEmpty } from "lodash";
import { TbLogout } from "react-icons/tb";
import { logo } from "../../../assets";
import { decodeJWT } from "../../../utils";
import {
  HiOutlineShoppingBag,
  HiOutlineUserGroup,
  HiOutlineNewspaper,
  HiExclamation
} from "react-icons/hi";
import { MdOutlineHome } from "react-icons/md";
import { FaBars } from "react-icons/fa";
import { useState } from "react";

const AdminMobileMenu = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const token = localStorage.getItem("token");
  const isLogin = !isEmpty(token);
  const roleName = decodeJWT(token)?.usertype;

  if (!isLogin || roleName !== "ADMIN") return <Navigate to="/" replace />;

  return (
    <>
      {/* Menu button with hamburger icon */}
      <div className="lg:hidden fixed top-4 right-4 z-50">
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="p-3 bg-gray-200 rounded-full hover:bg-gray-300 transition-all duration-200 shadow-md"
        >
          <FaBars size={20} className="text-yellow-600" />
        </button>

        {/* Dropdown menu */}
        {isMenuOpen && (
          <div className="absolute top-14 right-0 w-56 bg-gray-200 rounded-xl p-2 space-y-1 shadow-xl border border-yellow-200">
            {/* Logo at the top of the menu */}
            <div className="flex justify-center py-3 border-b border-yellow-200 border-opacity-50">
              <img src={logo} alt="Logo" className="h-12 w-12" />
            </div>

            <Link
              to="/Public/Home"
              className="flex items-center w-full px-4 py-3 
                         text-gray-800 hover:text-yellow-600 hover:bg-gray-100
                         rounded-lg transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              <MdOutlineHome size={20} className="ml-3 text-yellow-600" />
              صفحه اصلی
            </Link>

            <Link
              to="/Admin/Dashboard/News"
              className="flex items-center w-full px-4 py-3 
                         text-gray-800 hover:text-yellow-600 hover:bg-gray-100
                         rounded-lg transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              <HiOutlineNewspaper size={20} className="ml-3 text-yellow-600" />
              اخبار
            </Link>

            <Link
              to="/Admin/Dashboard/Requests"
              className="flex items-center w-full px-4 py-3 
                         text-gray-800 hover:text-yellow-600 hover:bg-gray-100
                         rounded-lg transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              <HiExclamation size={20} className="ml-3 text-yellow-600" />
              درخواست‌ها
            </Link>

            <Link
              to="/Admin/Dashboard/Products"
              className="flex items-center w-full px-4 py-3 
                         text-gray-800 hover:text-yellow-600 hover:bg-gray-100
                         rounded-lg transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              <HiOutlineShoppingBag size={20} className="ml-3 text-yellow-600" />
              محصولات
            </Link>

            <Link
              to="/Admin/Dashboard/Users"
              className="flex items-center w-full px-4 py-3 
                         text-gray-800 hover:text-yellow-600 hover:bg-gray-100
                         rounded-lg transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              <HiOutlineUserGroup size={20} className="ml-3 text-yellow-600" />
              کاربران
            </Link>

            <div className="border-t border-yellow-200 border-opacity-50 my-1"></div>

            <Link
              to="/Log-Out"
              className="flex items-center w-full px-4 py-3 
                         text-gray-800 hover:text-yellow-600 hover:bg-gray-100
                         rounded-lg transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              <TbLogout size={20} className="ml-3 text-yellow-600" />
              خروج از حساب
            </Link>
          </div>
        )}
      </div>
    </>
  );
};

export default AdminMobileMenu;